module.exports = __webpack_public_path__ + "static/media/23000139_1638432532898598_3354350741990009393_o-thumb.9100b6a5.jpg";